<template lang="pug">
.result-general.notification.is-success-light.has-text-left(:class="{'mb-10': paddingBottom, 'mb-0': !paddingBottom}")
  .fs-16
    b Are you a content creator?
  .mt-10
    p.small-content
      span Get an easy to remember referral code to use on your social networks!
    p.small-content
      span Apply to our 
      router-link(:to="'/referrals#content-creator'")  Custom Referral Code 
      span program to get better benefits and more rewards.
    p.small-content Join now!
</template>

<script>
export default {
  name: 'c_content_creator_link',
  data() {
    return {
    }
  },
  props: ['paddingBottom']
}
</script>

<style lang="stylus" scoped>
  .is-success-light
    padding 1.2rem 1.5rem 1.2rem 1.5rem
    background-color: #e5ffe5;
</style>



// WEBPACK FOOTER //
// c_content_creator_link.vue?14782864